import { EmailIcon } from "@chakra-ui/icons";
import { Center, Heading, Text, Flex, Box } from "@chakra-ui/react";
import { BsInstagram, BsMailbox, BsWhatsapp } from "react-icons/bs";

export const Contact = () => {
  return (
    <>
      <Center>
        <Flex direction={"column"}>
          <Heading>Contáctanos!</Heading>
          <Box mt={5}>
            <Text display={"flex"} alignItems="center" flexDirection={"row"}>
              <BsWhatsapp style={{ marginRight: "10px" }} />
              +54-1111-111111
            </Text>
            <Text display={"flex"} alignItems="center" flexDirection={"row"}>
              <BsInstagram style={{ marginRight: "10px" }} />
              @funkopop_store_cdelu
            </Text>
            <Text display={"flex"} alignItems="center" flexDirection={"row"}>
              <EmailIcon style={{ marginRight: "10px" }} />
              contacto@funkopopstorecdelu.com
            </Text>
          </Box>
        </Flex>
      </Center>
    </>
  );
};
